import {RefObject, useEffect} from 'react';

export const useResizeObserver = (
  elements: Array<RefObject<Element | null> | null | undefined>,
  onResize: () => void,
) => {
  useEffect(() => {
    const nodes = elements
      .map((element) => element?.current)
      .filter((node): node is Element => Boolean(node));

    if (!nodes.length) return;

    const observer = new ResizeObserver(() => {
      onResize();
    });

    nodes.forEach((node) => {
      observer.observe(node);
    });

    return () => observer.disconnect();
  }, [elements, onResize]);
};
